<template>
  <div class="container">
    <wx-open-subscribe @success="subscribeSuccess($event)" @error="subscribeError($event)" :template="templateIds" id="subscribe-btn" >
      <slot name="subscribe-slot" />
    </wx-open-subscribe>
  </div>
</template>

<script>
import { userMixin } from '../../assets/js/mixin/user'
let wx = require('weixin-js-sdk')
export default {
  name: "wechat-open-subscribe",
  mixins: [userMixin],
  props: {
    templateIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // templateIds: ['zSDGEwRWRQrCr01_S56x1MYolOV1wNdTLtIph36eyjY']
    }
  },
  methods: {
    subscribeSuccess(e) {
      this.handleClick()
      let { errMsg } = e.detail
      if (errMsg === 'subscribe:ok') {
        let subscribeDetail = JSON.parse(e.detail.subscribeDetails)
        let subscribe_id = []
        for (let i in subscribeDetail) {
          let obj = JSON.parse(subscribeDetail[i])
          if (obj.status === 'accept') {
            subscribe_id.push(i)
          }
        }
        this.$api.cv.wechatSubscribe(this.cvAccountToken, { subscribe_id }).then(res => {
          if (res.code === 1000) {

          }
        })
      }
    },
    subscribeError(e) {
      // alert(JSON.stringify(e.detail))
      // alert('error')
      this.handleClick()
    },
    // 自定义点击事件
    handleClick() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  overflow: hidden;
  z-index: 9999;
  #subscribe-btn {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9999;
  }
}
</style>